import { FileUploadActionField } from 'schemaBuilder/types';
import { ConverterFieldPayload } from 'schemaBuilder/converter/types';
import { ResolvedExpressionType, StatementType } from '@stratumn/dsl';
import { fileSchema } from 'utils/forms';
import { key } from '../utils';

export default (field: FileUploadActionField): ConverterFieldPayload => ({
  jsonSchema: {
    type: 'object',
    properties: {
      [key(field)]: {
        type: 'array',
        title: field.schemaField.label,
        ...(!field.schemaField.enableMultipleFiles && { maxItems: 1 }),
        items: fileSchema
      }
    },
    required: field.required ? [key(field)] : undefined
  },
  uiSchema: {
    'ui:order': [key(field)],
    [key(field)]: {
      'ui:field': 'FileUploadField'
    }
  },
  effects: [
    {
      $tags: ['schemaBuilder'],
      $statement: StatementType.SetVariable,
      path: `state.data.${key(field)}`,
      value: {
        $expression: ResolvedExpressionType.Variable,
        query: `formData.${key(field)}`
      }
    }
  ]
});
